import { Component, OnInit, AfterViewInit, Input  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';

declare var VConsole: any;
declare var polyvObject: any;

@Component({
  selector: 'app-learning-project',
  templateUrl: './learning-project.component.html',
  styleUrls: ['./learning-project.component.css']
})
export class LearningProjectComponent implements OnInit, AfterViewInit {
  //学习地图信息
  projectMsg: Array<any>; // 项目列表
  isPC = false;
  assetsRoute = '../../assets';
  isShowPrompt = false; //是否显示toast
  projectId: string;
  promptText: string;
  circleTheme = {
    'width': 300, //环形长度
    'height': 300, //环形高度
    'x': 0, //圆心x坐标
    'y': 0, //圆心y坐标
    'radius': 90, //外环半径
    'innerRadius': 20, //圆环厚度
    'startAngle': 0, //开始角度
    'endAngle': 360, //结束角度
    'angleRadian': 275, //环形轨迹角度
    'colors': ['#7E9FFB', '#5F81DB', '#60B68A', '#44976C', '#EEE'] //环形颜色
  }; //主题
  progressBarTheme: any = {
    'name': 'project',
    'haveTitle': true,
    'color': 'rgb(105,136,238)',
    'radius': '0.2rem'
  }; //主题
  isShowBar = true; //是否显示进度条
  postData: any = []; //传递数据
  player: any;
  isShowvideoDialog = false;  // 是否显示播放器
  isShowVideoBtn = false;  // 是否显示启动视频按钮
  isClickPlay = false;  // 是否点击过播放按钮
  campList: Array<any>; // 训练营数据列表
  homeWorkLock = false;
  buttonTheme: any = {
    'position': 'bottom',
    'fontSize': 'fontSize15',
    'buttonElem': [
      {
        'color': 'blue',
        'text': '进入学习',
        'className': 'inlineBlockRadiusBtn'
      }
    ]
  }; //按钮主题
  videoId = '';  // 宣讲视频id
  courseDuration = {
    0: '35min',
    1: '1h 30min',
    205: '1h 30min',
    305: '1h 50min',
    315: '1h 50min',
    325: '1h 50min',
    335: '1h 50min',
    405: '1h 30min',
    605: '2h 30min',
    2: '1h 25min',
    11: '1h 10min',
    403: '1h 10min',
    12: '60min',
    13: '1h 20min',
    14: '1h 20min',
    15: '1h 20min',
    607: '2h 20min',
    307: '1h 35min',
    317: '1h 55min',
    327: '1h 35min',
    16: '1h 15min',
    18: '25min',
    404: '1h 25min',
    20: '1h 20min',
    24: '2h 20min',
    406: '2h 20min',
    606: '3h 20min',
    26: '1h 20min',
    28: '1h 20min',
    30: '2h 20min',
    201: '2h',
    301: '2h 20min',
    202: '1h 40min',
    302: '2h',
    312: '2h',
    402: '1h 40min',
    208: '1h 30min',
    209: '2h 10min',
    210: '2h 10min',
    308: '1h 35min',
    211: '1h 40min',
    212: '1h 50min',
    304: '1h 40min',
    311: '2h 20min',
    309: '1h 35min',
    318: '1h 35min',
    303: '1h 30min',
    204: '1h 55min',
    6001: '38min'
  };
  tabList: Array<any> = [];
  tabType = 0;
  tabIndex = 0;
  isFirstAITraining = true;
  isHaveAITraining = false;
  guideTipCon = '沉浸式真人陪练，再也不用“话到嘴边说不出口”。';
  guideTipBtn = '下一步';
  stepNum = 0; //新手引导点击的次数
  firstAITrainingData: object = {}; //智能陪练列表里的第一个card数据
  allTotalNum = 0; //智能陪练中tab全部的数量
  isStickey = false; //是否吸顶
  ArrPos: any= []; //记录滚动的距离
  tour_id = 0;
  guideStyle = false;
  totalProgress = 0;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private commonService: CommonService) {}

  ngOnInit() {
    this.ArrPos = JSON.parse(localStorage.getItem('scrollHeight')) ? JSON.parse(localStorage.getItem('scrollHeight')) : [];
    // 清除训练营相关信息
    localStorage.removeItem('skuId');
    localStorage.removeItem('campId');
    localStorage.removeItem('moduleId');
    localStorage.removeItem('learningPathMetaId');
    localStorage.setItem('learningPathMetaId', '');
    //进入学地图时,各能力学习时长不计时
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.isPC = localStorage.getItem('isPC') ? true : false;
    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      localStorage.setItem('projectId', this.projectId);
    });
    const self = this;
    // 获取项目下课程列表信息
    this.getProjectProgress(this.projectId).then(res => {
      localStorage.removeItem('projectmsg');
      if (res[0].totalCourseNum && res[0].totalCourseNum > 0){
        res[0].learningPathMetasDetailList.forEach(item => {
          if (item.projectLearingToursVo){
            const preTestOpenAt = item.projectLearingToursVo.preTestOpenAt;
            item.projectLearingToursVo.openTime = preTestOpenAt ? this.tansFromTimestamp(preTestOpenAt, 1) : '';
            item.projectLearingToursVo.promptTime = preTestOpenAt ? this.tansFromTimestamp(preTestOpenAt, 2) : '';
          }
        });
      }

      if (res[0].totalCampMetasNum && res[0].totalCampMetasNum > 0){
        res[0].campMetasList.forEach(item => {
          item.campOpenTime = item.preTestOpenTime ? self.tansFromTimestamp(item.preTestOpenTime, 1) : '';
        });
      }

      let learningPathMetasDetailList = [];
      learningPathMetasDetailList = res[0].learningPathMetasDetailList.filter(item => item.learningPathMetaId != 999);
      res[0].learningPathMetasDetailList = learningPathMetasDetailList;
      if (res[0].campMetasList.length > 0) {
        res[0].learningPathMetasDetailList = res[0].learningPathMetasDetailList.filter(item => item.learningPathMetaId !== 0);
      }
      self.projectMsg = res;
      self.totalProgress = self.projectMsg[0].totalProgress;
      //项目里是否含有智能陪练
      this.isHaveAITraining = self.projectMsg[0].learningPathMetasDetailList.filter(item => item.abilityVersion == '智能陪练').length > 0;
      this.getProjectData();
    }).then(() => {
      if (self.projectMsg[0].videoId){
        self.isShowVideoBtn = true;
        self.videoId = self.projectMsg[0].videoId;
        if (self.projectMsg[0].isPopUp){
          self.openVideo();
        }
      }else{
        self.isShowVideoBtn = false;
      }

      this.CoursesOrProjectCourses(this.projectId).then(res => {
        const contTxt = self.projectMsg[0].learningPathMetasDetailList;
        contTxt.forEach((item, index) => {
          res.learning_path_metas.forEach(itm => {
            if (item.learningPathMetaId == itm.id){
              contTxt[index] = {...item, ...itm};
            }
          });
        });
        self.tour_id = res.tour_id;
        self.projectMsg[0].tour_id = res.tour_id;
        self.commonService.setStorage('tourId', self.projectMsg[0].tour_id);
      });

      console.log(self.projectMsg);

      self.campList = [
        {
          id: 1,
          projectName: '训练营1',
          description: '124567',
          campMetasId: 2,
        }
      ];
    });


  }

  // 时间转化
  tansFromTimestamp(timestamp, type){
    const date = new Date(timestamp);
    const Y = date.getFullYear();
    const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    const m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    if (type == 1){
      return `${M}.${D}`;
    }else if (type == 2){
      return `${Y}-${M}-${D} ${h}:${m}`;
    }else if (type === 3){
      return `${M}/${D}`;
    }
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': '#F2F3FA'
    });
  }

  setPinpointPicture(id) {
    const courseName = this.commonService.getPinpointCourseEnNameById(id);
    if (!courseName) {
      console.warn(`No course name found for id: ${id}`);
      return ''; // 或者返回一个默认图片 URL
    }
    return 'https://ddileaf-uat-oss.oss-cn-shanghai.aliyuncs.com/scorm/pinpoint/' + encodeURIComponent(courseName.trim());
  }

  setGuideStyle(){
    if (!this.isFirstAITraining){//设置新手引导style
      setTimeout(() => {
        const dom = document.getElementById('learning-Item');
        if (dom && document.getElementById('guideCon') && document.getElementById('guideTip')){
          document.getElementById('guideCon').style.width = dom.offsetWidth + 'px';
          document.getElementById('guideCon').style.height = dom.offsetHeight + 'px';
          document.getElementById('guideCon').style.top = dom.offsetTop + 'px';
          document.getElementById('guideCon').style.left = dom.offsetLeft + 'px';
          document.getElementById('guideTip').style.top = dom.offsetTop + dom.offsetHeight + 24.5 + 'px';
          this.guideStyle = true;
          this.changePos(this.tabIndex);
        }

      }, 200);
    }
  }

  // 储存用户滚动位置
  listenScrollTop(scrollTop){
    const debounce = () => {
      let timer = null;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        if (!this.ArrPos.find(item => item.index == this.tabIndex)){
          this.ArrPos.push({
          index: this.tabIndex,
          scrollTop: scrollTop
        });
        sessionStorage.setItem('scrollHeight', JSON.stringify(this.ArrPos));
        }else{
          this.ArrPos.find(item => item.index == this.tabIndex).scrollTop = scrollTop;
          sessionStorage.setItem('scrollHeight', JSON.stringify(this.ArrPos));
        }
      }, 200);

    };
    debounce();
 }

  //判断是否之前已经存储过浏览位置 有则直接定位到浏览位置 否则画到顶部
  judgePos(){
    const scrollHeight = JSON.parse(sessionStorage.getItem('scrollHeight'));
    if (scrollHeight.find(item => item.index == this.tabIndex)){
      const scrollTop = scrollHeight.find(item => item.index == this.tabIndex).scrollTop;
      this.scrollToView(scrollTop);
    }else{
      document.getElementById('learningWrap-out').scrollTo({
        top: 240,
        behavior: 'smooth'
      });
    }
  }

  // 滚动到 上次访问位置
  scrollToView(scrollTop){
    setTimeout(() => {
      document.getElementById('learningWrap-out').scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }, 700);
  }

  elementScroll(event){
      const scrollTop = event.target.scrollTop;
      if (scrollTop > 235){
        this.isStickey = true;
      }else{
        this.isStickey = false;
      }
      if (this.isStickey){
        this.listenScrollTop(scrollTop);
      }
      this.changePos(this.tabIndex);
  }

  // 获取项目列表
  getProjectData(){
    //获取当前项目下课程分类
    this.apiService.getProjectSort(Number(this.projectId)).subscribe(res => {
      this.tabList = res.filter(item => item.totalNum > 0);
      this.allTotalNum = this.tabList.find(item => item.type === 0).totalNum;
      this.commonService.getOnceIno(this.commonService.getOnceValue(this.projectId, 15)).then(result => {
        this.isFirstAITraining = result;
        this.setGuideStyle();
        //从当前课程退出来定位在之前的tab
        this.tabIndex = sessionStorage.getItem('tabIndex') ? Number(sessionStorage.getItem('tabIndex')) : 0;
        this.tabType = sessionStorage.getItem('tabType') ? Number(sessionStorage.getItem('tabType')) : 0;
        //从智能陪练短链进来code为101 课程未开放/过期 自动定位到智能陪练
        this.route.queryParams.subscribe(params => {
          if (params['code'] == 101){
            this.tabIndex = this.tabList.findIndex(item => item.type === 2);
          }
        });
        this.changePos(this.tabIndex);
        if (Number(sessionStorage.getItem('tabIndex')) && Number(sessionStorage.getItem('tabType')) && this.projectMsg[0].learningPathMetasDetailList.length > 0){//只有训练营的项目不展示tab
          this.checkTab(this.tabIndex, this.tabType);
        }
        if (!this.isFirstAITraining && this.isHaveAITraining){//第一次引导需要定位在智能陪练tab上
          this.tabIndex = this.tabList.findIndex(item => item.type === 2);
          this.apiService.getProjectSortList(Number(this.projectId), 2).subscribe(result => {
            this.projectMsg = result;
            this.firstAITrainingData = result[0].learningPathMetasDetailList[0];
            this.firstAITrainingData['projectLearingToursVo'].openTime = this.firstAITrainingData['projectLearingToursVo'].preTestOpenAt ? this.tansFromTimestamp(this.firstAITrainingData['projectLearingToursVo'].preTestOpenAt, 1) : '';
          });
        }
      });
    });
  }

  //项目列表接口和项目学习进度接口
  getProjectProgress(projectId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/projectProgress?needDetails=true&projectIds=' + projectId,
    }).toPromise();
  }

  //获取项目下课程列表或者散客列表
  CoursesOrProjectCourses(projectId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'sr/v2/coursesOrProjectCourses?projectId=' + projectId,
    }).toPromise();
  }

  //获取项目下课程列表或者散客列表
  changPlayBroadcast(vid){
    return this.apiService.ajax({
      'type': 'GET',
      'url': `ddilearner/v2/broadcast?vid=${vid}`,
    }).toPromise();
  }

  /**
   * 进入作业
   */
  goHomeWork(item: any): void{
    if (item.homeworkExpiryAtFlag){
      this.lockToast();
      this.promptText = `该作业已过期`;
    }else if (!item.homeworkOpenAtFlag){
      this.lockToast();
      this.promptText = '该作业将于' + this.tansFromTimestamp(item.homeworkOpenAt, 2) + '开放。';
    }else{
      if (item.homeworkProgress === 100 || item.homeworkCloseAtFlag){
        // alert('正在施工中...');
        if (item.constituteId !== null && item.constituteId > 0){
          this.router.navigate(['learning-camp-response'], { queryParams: { tabNum: 0, constituteId: item.constituteId, projectId: this.projectId, 'homeworkCloseAtFlag': item.homeworkCloseAtFlag ? 1 : 0} }).then();
        }else{
          this.router.navigate(['home-work-show', item['homeworkDuplicateId']], {queryParams: {'projectId': this.projectId, 'tabNum': 0, 'homeworkCloseAtFlag': item.homeworkCloseAtFlag ? 1 : 0}}).then();
        }
      }else{
        if (item.constituteId !== null && item.constituteId > 0){
          this.router.navigate(['exercise-work', item['constituteId']], {queryParams: {projectId: this.projectId}});
        }else{
          this.router.navigate(['home-work', this.projectId, item['homeworkDuplicateId']]).then();
        }
      }
    }
  }

  // 进到课程学历里面
  goLearnPath(raw): void {
    console.log('课程信息', raw);
    if (raw.isUserTicketExpiry){
      this.lockToast();
      this.promptText = `该课程已过期`;
    }else if (raw.projectLearingToursVo.lock){
      this.lockToast();
      this.promptText = `该课程将于${raw.projectLearingToursVo.promptTime ? raw.projectLearingToursVo.promptTime : this.tansFromTimestamp(raw.projectLearingToursVo.preTestOpenAt, 2)}开放。`;
    }else{
       if (Number(raw.learningPathMetaId) > 5000 && Number(raw.learningPathMetaId) < 6000) {
          this.router.navigate(['app-scorm', raw.learningPathMetaId], { queryParams: { version: raw.abilityVersion, name: raw.name, projectId: this.projectId } });
       } else {
          let link = ['learning-path', raw.id ? raw.id : raw.learningPathMetaId];
      if (raw.abilityVersion === '智能陪练'){
        let exerciseIds = '';
        this.route.queryParams.subscribe(params => {
          exerciseIds = params.exerciseIds && params.exerciseIds != 'undefined' ? params.exerciseIds : '';
        });
        this.getOrCreateLearningPath(raw.learningPathMetaId).then(() => {
          const token = localStorage.getItem('transtalen-token') ? localStorage.getItem('transtalen-token') : '';
          const mobProjectUrl = window.location.origin + '/learning-project/' + this.projectId; //mob项目列表
          const IntelligentUrl = window.location.origin + '/ai/aicoach/list/' + raw.courseId + '?device=mobile' + '&projectId=' + this.projectId + '&exerciseIds=' + exerciseIds + '&back_url=' + encodeURIComponent(mobProjectUrl) + '&transtalent_token=' + token;
          window.location.href = IntelligentUrl;
        });
        return;
      }
      if (raw.learningPathMetaId == 0){
        this.commonService.setStorage('dnaReturnUrl', location.href);
        link = ['survey', this.projectMsg[0].tour_id ? this.projectMsg[0].tour_id : this.tour_id, 1, 2];
      }
      this.router.navigate(link);
       }
    }

  }
  // 课程锁住原因提示
  lockToast(){
    this.isShowPrompt = true;
    setTimeout(() => {
      this.isShowPrompt = false;
    }, 2000);
  }

  // 返回课程列表页面
  goToLearningMap(){
    this.router.navigate(['learning-map']);
    sessionStorage.removeItem('scrollHeight');
    sessionStorage.removeItem('tabIndex');
    sessionStorage.removeItem('tabType');
  }

  // 打开宣讲视频窗口
  openVideo(){
    // console.log('打开宣讲视频弹窗')
    this.isShowvideoDialog = true;
    setTimeout(() => {
      console.log(window.frames.innerWidth);
      this.initVideoPlayer(window.frames.innerWidth, window.frames.innerWidth / 16 * 9);
    }, 300);
  }

  // 进入学习
  goNext(evn){
    this.player.destroy();
    this.isShowvideoDialog = false;
  }

  // 视频播放设置
  initVideoPlayer(width, height){
    const self =  this;
    const player = polyvPlayer({
      wrap: '#video',
      'width': width,
      'height': height,
      'vid': this.videoId,
      'forceH5': true
    });
    this.player = player;

    this.player.on('s2j_onPlayStart', () => {
      if (!self.projectMsg[0].isBroadcast){  // 未播放过
        if (self.isClickPlay){
          return false;
        }
        self.changPlayBroadcast(self.videoId);
        self.isClickPlay = true;
      }
   });
  }

  //进入训练营
  goCampList(skuId, campId){
    localStorage.setItem('skuId', skuId);
    localStorage.setItem('campId', campId);
    this.router.navigate(['learning-camp', skuId, campId]);
  }

  //切换
  checkTab(index, type){
    this.tabIndex = index;
    this.tabType = type;
    if (this.isStickey){
      this.judgePos();
    }
    this.changePos(this.tabIndex);
    this.apiService.getProjectSortList(Number(this.projectId), type).subscribe(result => {
      //把含有小工具的过滤掉
      result[0].learningPathMetasDetailList = result[0].learningPathMetasDetailList.filter(item => item.learningPathMetaId !== 999);
      this.projectMsg = result;
      //有训练营需要过滤掉dna
      if (this.projectMsg[0].campMetasList.length > 0) {
        this.projectMsg[0].learningPathMetasDetailList = this.projectMsg[0].learningPathMetasDetailList.filter(item => item.learningPathMetaId !== 0);
      }
      //重新设置训练营的campOpenTime
      if (this.projectMsg[0].totalCampMetasNum && this.projectMsg[0].totalCampMetasNum > 0){
        this.projectMsg[0].campMetasList.map(item => {
          item.campOpenTime = item.preTestOpenTime ? this.tansFromTimestamp(item.preTestOpenTime, 1) : '';
        });
      }
      //设置智能陪练课程开放时间
      this.projectMsg[0].learningPathMetasDetailList.forEach(item => {
        if (item.projectLearingToursVo){
          const preTestOpenAt = item.projectLearingToursVo.preTestOpenAt;
          item.projectLearingToursVo.openTime = preTestOpenAt ? this.tansFromTimestamp(preTestOpenAt, 1) : '';
          item.projectLearingToursVo.promptTime = preTestOpenAt ? this.tansFromTimestamp(preTestOpenAt, 2) : '';
        }
      });
      //切换到每个tab下的数量是否不够屏幕滚动的数量 不够添加
      for (let i = this.tabIndex == 0 ? this.projectMsg[0].totalCampMetasNum + this.projectMsg[0].learningPathMetasDetailList.length : this.projectMsg[0].learningPathMetasDetailList.length; i < 6; i++){
        this.projectMsg[0].learningPathMetasDetailList.push({});
      }
    });
    if (this.isStickey && this.tabIndex == this.tabList.length - 1){
      document.getElementById('tabBar').scrollTo({
        left: 10,
        behavior: 'smooth'
      });
    }
    sessionStorage.setItem('tabIndex', String(this.tabIndex));
    sessionStorage.setItem('tabType', String(this.tabType));
  }

  changePos(index){
    //改变滑条距离
    const tabItem = document.getElementById(`tabItem-${index}`);
    const firstTabItem = document.getElementById(`tabItem-0`);
    document.getElementById('line').style.width = tabItem.offsetWidth - 5 + 'px';
    document.getElementById('line').style.transform = this.isStickey ? `translateX(${tabItem.offsetLeft - firstTabItem.offsetLeft}px)` : index == 0 ? `` : `translateX(${tabItem.offsetLeft}px)`;
  }

  //去下一步
  goNextStep(){
    this.stepNum ++ ;
    if (this.stepNum == 1){
      this.guideTipCon = '点击全部，查看你的学习旅程，开始学习吧。';
      this.guideTipBtn = '知道了';
      const dom = document.getElementById('tabBar');
      document.getElementById('guideTip').style.top = dom.offsetTop + 34 + 14 + 'px';
      document.getElementById('guideTip').style.left = 15 + 'px';
      document.getElementById('arrow').style.left = 15 + 'px';
    }else{
      document.getElementById('mask').style.display = 'none';
      //做完新手引导
      this.commonService.setOnceIno(this.commonService.getOnceValue(this.projectId, 15)).subscribe(res => {
        this.isFirstAITraining = true;
      });
    }
  }

  // 根据learningPathMetaId创建或者获取LearningPath
  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learningpathes/' + learningPathMetaId
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/learning-project/learning-project.component.ts